import { delegateListener } from './delegate-listener';
import { defaultAlertModal } from '../utils';

const offers = /^¡Hey! Te he hecho una oferta por [^\s]+\. ¿Aceptas\?$|^¡Acepto tu oferta! Es tu oportunidad\.$|^Lo siento mucho, no puedo aceptar tu oferta\.$/;

const handler = e => {
    if (e.target.closest('.trendier-help-comment')) {
        return;
    }

    if (e.target.innerText.trim().match(offers)) {
        return;
    }
    defaultAlertModal('<h2 class="text-center mb-2">⚠️ Atención</h2><p>Este mensaje no es de GoTrendier.<br>Evita estafas.<b> No sigas enlaces ni compartas tus datos</b> personales o de pago.</p>');
    e.preventDefault();
    return false;
};

delegateListener('dblclick', '.comment-text', handler);
delegateListener('contextmenu', '.comment-text', handler);
delegateListener('dblclick', '.product-description-text', handler);
delegateListener('contextmenu', '.product-description-text', handler);
